import { Component, OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';
import { ActivatedRoute, Params, Router, PRIMARY_OUTLET, NavigationEnd, RouterEvent } from '@angular/router';
interface IBreadcrumb {
  label: string;
  params: Params;
  url: string;
  allowLink: boolean;
}


@Component({
  selector: 'app-manual-breadcrumbs',
  templateUrl: './manual-breadcrumbs.component.html',
  styleUrls: ['./manual-breadcrumbs.component.css']
})
export class ManualBreadcrumbsComponent implements OnInit {

  @Input('list') public breadcrumbs: IBreadcrumb[];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {    
  }

  ngOnInit() {
  }

  public isLastChild(breadcrumb: IBreadcrumb) {
    var idx = this.breadcrumbs.indexOf(breadcrumb);
    return idx + 1 === this.breadcrumbs.length;
  }


  handleUrl(url: string) {
    if (!url) {
      return undefined;
    }
    else if (url.indexOf("../") !== -1) {
      var numOfBacks = url.split("../").length -1;

      var curUrl = window.location.pathname;

      for (let i = 0; i < numOfBacks; i++) {
        curUrl = curUrl.substr(0, curUrl.lastIndexOf("/"));        
      }

      return curUrl;
    }
    else {
      return url;
    }
  }

}
